export default __webpack_public_path__ + "static/comment-4baf838f163bb1266af44ffab826b9e4.webp";